import { advertisingKeys } from "./buyerKeys";

/**
 * The advertising reads the shared `advertisingKeys` factory does not name.
 *
 * <p>They live in their own `*Keys` file rather than inline at the call site
 * because `staleAfterSaveGate` allows a `queryKey: [` array literal ONLY in a
 * keys factory — and rightly: a key written at the call site is a key no
 * invalidation can be checked against.</p>
 *
 * <p>Every member is deliberately built FROM `advertisingKeys.all`, so the
 * single `invalidateQueries({ queryKey: advertisingKeys.all })` every
 * advertising mutation issues reaches it by prefix. Folding these into
 * `advertisingKeys` itself would be tidier and is the right long-term home.</p>
 */
export const advertisingViewKeys = {
  scope: () => [...advertisingKeys.all, "scope"] as const,
  /** The month-bucketed cost-per-lead report; `buyerTeamId` is part of the key
   *  because the server narrows on it and two callers with different teams
   *  must not share a cache entry. Under `all`, so recording spend or saving a
   *  budget refreshes the pace it feeds. */
  costPerLead: (from: string, to: string, buyerTeamId: string | null) =>
    [...advertisingKeys.all, "cost-per-lead", from, to, buyerTeamId ?? ""] as const,
};
